function getLocalStorageItem(key) {
    if (this.isLocalStorageAvailable()) {
        return localStorage.getItem(key);
    }
    return null;
}

function getLocalStorageObject(key, keepExpired = false) {
    if (!this.isLocalStorageAvailable()) {
        return null;
    }

    const value = localStorage.getItem(key);

    if (!value) {
        return null;
    }

    let object = null;
    try {
        object = JSON.parse(value);
    } catch (e) {
        return null;
    }

    if (object.expiration && !keepExpired) {
        const expirationDate = this.moment(object.expiration);
        const currentDate = this.moment();
        const objectExpired = expirationDate.isBefore(currentDate);

        if (objectExpired) {
            localStorage.removeItem(key);
            return null;
        }
    }

    return object.value;
}

function setLocalStorageItem(key, value) {
    if (this.isLocalStorageAvailable()) {
        localStorage.setItem(key, value);
        return true;
    }
    return false;
}

function setLocalStorageObject(key, value, expiration = null) {
    const payload = {
        value,
        expiration,
    }

    return this.setLocalStorageItem(key, JSON.stringify(payload));
}

function isLocalStorageAvailable() {
    if (typeof localStorage === "undefined" || !localStorage) {
        return false;
    }

    try {
        const test = 'testKey123qweasd';
        localStorage.setItem(test, test);
        localStorage.getItem(test);
        localStorage.removeItem(test);

        return true;
    } catch (e) {
        return false;
    }
}

function deleteLocalStorageItem(key) {
    if (this.isLocalStorageAvailable()) {
        localStorage.removeItem(key);
        return true;
    }

    return false;
}

const data = () => ({
    store: $store,
    moment: moment,
    escortCallFeedbackKey: 'escortCallFeedback',
});

export default {
    data,
    methods: {
        getLocalStorageItem,
        isLocalStorageAvailable,
        setLocalStorageItem,
        setLocalStorageObject,
        getLocalStorageObject,
        deleteLocalStorageItem,
    },
}
